import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
// import usePrams -> to get showid from url in details page
import { fetchAll } from "../../redux/actions/FetchActions";
import { fetchBoth } from "../../redux/reducers/FetchReducer";
import DisplayCard from "./DisplayCard";

function DisplayList() {
    const dispatch = useDispatch();
    const bothShows = useSelector((state) => state.allData.home); // state.allData.bothShows for all bothShows
    
    useEffect(() => {
        fetchAll().then((res)=>{
            dispatch(fetchBoth(res.data.results));
        });        
    }, []);
    
    return (
        <div className="flex pb-5 px-5 overflow-x-auto">
            { bothShows?.map((movie) => {
                return <DisplayCard key={movie.id} movie={movie} />
            })}
            {/* onClick={()=> navigate(`/movies/${movie.id}`)} */}
        </div>
        
    );
}

export default DisplayList;
